var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 77.6,
    viewBox: "0 0 64 77.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M9.7,16.6c-3.4,0-4.6-2.2-4.6-4,0-2.4,2-4,4.9-4h.5V7.9H12v7.2H22.3V8.6h1.5v6.5h9.6V8.6h1.5v8Zm-.2-6.5a2.767,2.767,0,0,0-2.9,2.5c0,1.7,1.4,2.5,2.9,2.5h.9v-5Zm2.6-4.2a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9.923.923,0,0,0,1,.9.923.923,0,0,0,1-.9m-2.7,0a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9.923.923,0,0,0,1,.9.923.923,0,0,0,1-.9M24,18.6a1.006,1.006,0,0,0-2,0,1,1,0,0,0,1,1,.945.945,0,0,0,1-1m8.6,0a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9.923.923,0,0,0,1,.9.865.865,0,0,0,1-.9m2.7,0a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9.923.923,0,0,0,1,.9.827.827,0,0,0,1-.9m2.5,1.1a3.751,3.751,0,0,1-1-.1l-.2-.1L37,18h.2a1.338,1.338,0,0,0,.5.1c.7,0,.9-.2.9-1.5V8.5h1.5V15h9.1V8.5h1.5v.9h5a3.253,3.253,0,0,1,2.6,1,3.444,3.444,0,0,1,.7,2.4v3.8H40v.1a3.575,3.575,0,0,1-.6,2.5A2.4,2.4,0,0,1,37.8,19.7Zm13-4.6h6.7V12.9a1.7,1.7,0,0,0-.4-1.3,1.624,1.624,0,0,0-1.4-.5h-5v4Zm4.3-7.9a1,1,0,0,0-1-1,.945.945,0,0,0-1,1,1,1,0,0,0,1,1,1.166,1.166,0,0,0,1-1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M11.1,23.7a.9.9,0,1,1,0-1.8.9.9,0,1,1,0,1.8m-1.7-.9a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9.923.923,0,0,0,1,.9.987.987,0,0,0,1-.9M33,35.6a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9,1.006,1.006,0,0,0,2,0m2.8,0a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9,1.006,1.006,0,0,0,2,0m8.5-12.2a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9.923.923,0,0,0,1,.9.987.987,0,0,0,1-.9m2.7,0a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9,1.006,1.006,0,0,0,2,0M25.2,33.6H54.7V21.7H53.2V32H47.5V25.5H45.4c-2.9,0-4.8,1.6-4.8,4a3.583,3.583,0,0,0,.9,2.4l.1.1H34.4V25.5H32.9V32H26.3v-.1a5.9,5.9,0,0,0,.2-1.4,4.25,4.25,0,1,0-8.5,0,6.753,6.753,0,0,0,.2,1.4V32H12V24.8H10.5v.7H10c-2.9,0-4.9,1.7-4.9,4,0,1.9,1.3,4,4.9,4h9.1a4.335,4.335,0,0,0,3,1.3,4.471,4.471,0,0,0,3.1-1.2m-.3-3.1a2.75,2.75,0,1,1-2.8-2.8,2.8,2.8,0,0,1,2.8,2.8m21-3.5v5H43.6A2.968,2.968,0,0,1,42,29.5,2.608,2.608,0,0,1,44.8,27ZM10.4,27v5H9.5a2.632,2.632,0,0,1-2.9-2.5A2.7,2.7,0,0,1,9.5,27ZM59,21.7H57.5V33.5H59Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M11.2,40.7a.905.905,0,1,1,0-1.8.923.923,0,0,1,1,.9,1.063,1.063,0,0,1-1,.9m-1.8-1a.923.923,0,0,0-1-.9.987.987,0,0,0-1,.9.923.923,0,0,0,1,.9.827.827,0,0,0,1-.9M21.2,50.5v-8H19.1c-2.9,0-4.8,1.6-4.8,4a3.583,3.583,0,0,0,.9,2.4l.1.1H11.9V41.8H10.4v.7H9.9C7,42.5,5,44.2,5,46.5c0,1.9,1.3,4,4.9,4Zm-1.5-6.6v5H17.5a2.968,2.968,0,0,1-1.6-2.5,2.617,2.617,0,0,1,2.8-2.5Zm-9.3,0v5H9.5a2.632,2.632,0,0,1-2.9-2.5,2.7,2.7,0,0,1,2.9-2.5Zm9.1-3.6a1,1,0,0,0-1-1,.945.945,0,0,0-1,1,1,1,0,0,0,1,1,1.166,1.166,0,0,0,1-1m14.9.7a1,1,0,0,0-1-1,.945.945,0,0,0-1,1,1,1,0,0,0,2,0m14.1,9.5h6.2V38.6H53.2V48.9H49.5v-.1a5.9,5.9,0,0,0,.2-1.4,4.25,4.25,0,1,0-8.5,0,6.752,6.752,0,0,0,.2,1.4v.1h-3V46.7a4.267,4.267,0,0,0-.7-2.4,3.122,3.122,0,0,0-2.6-1H30.3v-.9H28.8v6.5H25.1V38.6H23.6V50.4H42.4a4.345,4.345,0,0,0,6.1.1m-.3-3a2.75,2.75,0,1,1-2.8-2.8,2.677,2.677,0,0,1,2.8,2.8M30.3,44.8h4.8a1.978,1.978,0,0,1,1.4.5,1.7,1.7,0,0,1,.4,1.3v2.2H30.3S30.3,44.8,30.3,44.8ZM59,38.6H57.5V50.4H59Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M60.8,82.6H3.3A3.329,3.329,0,0,1,0,79.3V61.4a3.329,3.329,0,0,1,3.3-3.3H60.7A3.329,3.329,0,0,1,64,61.4V79.3a3.244,3.244,0,0,1-3.2,3.3",
    fill: "#d19e2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M14.1,74.9,18,61.8h5.4c-1.8,5.4-5.7,17-5.7,17H10.5s-3.9-11.6-5.7-17h5.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M59.3,61.8h-18l1.4,3.9h5.7V78.8h5.2V65.7h5.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M41.1,68.1l-.5-1.2c-2.8,1.8-7.5,7.4-7.5,7.4l-1.7-1.9-.6,2.1-.2.3c.7.9,2.4,4.1,2.4,4.1,4.2-7.6,8.1-10.8,8.1-10.8",
    fill: "#005e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M32.4,65.8l1.8,6a47.8,47.8,0,0,1,3.9-3.9l-2-6H28.9s-3.9,11.6-5.7,17h5.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M35.5,76.3l.8,2.6h5.4c-.7-2-1.6-4.8-2.5-7.6a29.426,29.426,0,0,0-3.7,5",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVat);
export default __webpack_public_path__ + "static/media/vat.b53c07218e3683e18560bf6007d27b5c.svg";
export { ForwardRef as ReactComponent };